export default __webpack_public_path__ + "static/media/KK_E_Right_Top_aCrop.def4e8c4.svg";